import { render } from "./tabsComponent.vue?vue&type=template&id=5eda5756&scoped=true"
import script from "./tabsComponent.vue?vue&type=script&lang=js"
export * from "./tabsComponent.vue?vue&type=script&lang=js"

import "./tabsComponent.vue?vue&type=style&index=0&id=5eda5756&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eda5756"]])

export default __exports__